
import {Modal,Button} from 'react-bootstrap'
import React from 'react'
import './confirm-dialog.css'

  type MyProps = {
    message:string;
    title:string,
    btnOkText:string,
    btnCancelText:string,
    size:any,
    handleResult: (boolean) => void,
  }

  type MyState = {
    showModal:boolean
  }



export class ConfirmDialog extends React.Component<MyProps> {

  state:MyState = {
    showModal:true
  }

    dismiss = () =>{
        this.setState({ showModal: false });
        this.props.handleResult(false)
      }
    accept = () => {
        this.setState({ showModal: false });
        this.props.handleResult(true)
    }
    decline = () => {
        this.setState({showModal:false})
        this.props.handleResult(false)
    }

    handleShow = () =>{
        this.setState({ showModal: true });
        return true
      }
      createMarkup(htmlText) {
        return {__html: htmlText};
      }
      stripHtml(html: string) {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || '';
      }
      render(){
        return (
          <Modal
            show={this.state.showModal}
            onHide={() => this.dismiss()}
            size={this.props.size}
            role="alertdialog"
            aria-labelledby="confirm-dialog-title"
            aria-describedby="confirm-dialog-body"
          >
              <Modal.Header>
                  <Modal.Title id="confirm-dialog-title">{this.props.title}</Modal.Title>
                  <button className="close" aria-label="Close dialog" onClick={() => this.dismiss()}>
                      <span aria-hidden="true">&times;</span>
                  </button>
              </Modal.Header>
              <Modal.Body
                id="confirm-dialog-body"
                dangerouslySetInnerHTML={this.createMarkup(this.props.message)}
                aria-label={this.stripHtml(this.props.message)}
              ></Modal.Body>
              <Modal.Footer>
                  <Button variant="primary" className="btn btn-primary" onClick={() => {
                    this.accept()
                  }}>
                      {this.props.btnOkText}
                  </Button>
                  <button type="button" className="btn btn-danger" onClick={() => this.decline()}>{ this.props.btnCancelText }</button>
              </Modal.Footer>
          </Modal>
    );
      }

  }
